/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Steps/Content/Step/Display/No"
  
}) {
let stepNameValueData = fromData.useDataFormat({ viewPath,
context: 'step',
path: 'name',
format: fromHelpers.getTitle,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="step.name"
 format="helpers.js getTitle"
 text={stepNameValueData}
 weight="medium"
 size="normal"
/>
{children}
</React.Fragment>)
}